export default __webpack_public_path__ + "static/media/check.a27dc66e.svg";